import store from "@/core/services/store";
import axios from "axios";
import { LOGOUT } from "@/core/services/store/actions.type";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import jwtService from "@/core/services/jwt.service";
import { SET_AUTH } from "@/core/services/store/mutations.type";

function setupAxios() {
  const setRefreshToken = async (tokenRefreshResponse) => {
    store.commit(SET_AUTH, tokenRefreshResponse.data.access);
    return Promise.resolve();
  };
  const refreshAuthLogic = async (failedRequest) => {
    store.dispatch(LOGOUT);
    let tokenRefreshResponse = await axios.post("token/refresh", {
      refresh: jwtService.getRefreshToken(),
    });
    failedRequest.response.config.headers["Authorization"] =
      "Bearer " + tokenRefreshResponse.data.access;
    return setRefreshToken(tokenRefreshResponse);
  };

  createAuthRefreshInterceptor(axios, refreshAuthLogic);
}

export default setupAxios;
